(function () {
  const rootPane = document.getElementById('menu-root');

  document.addEventListener('click', (e) => {
    /* ===== Klick auf 2.-Stufe mit Kindern → neues Pane ===== */
    const subParent = e.target.closest('.SubItem--parent');
    
    if (subParent) {
      const targetId  = subParent.dataset.target;
      const targetPane = document.getElementById(targetId);
      console.log(targetId, targetPane);
      if (!targetPane) return;

      rootPane.classList.add('is-left');          // Root nach links
      targetPane.classList.add('is-active');      // Unter-Pane herein
      document.body.classList.add('drawer-is-open');
      return;
    }

    /* ===== Back-Button ===== */
    const backBtn = e.target.closest('[data-action="back-to-parent"]');
    if (backBtn) {
      const curPane = backBtn.closest('.SidebarMenu__Pane');
      curPane.classList.remove('is-active');
      rootPane.classList.remove('is-left');
      return;
    }
  });
})();



